import { observer } from "mobx-react-lite";
import "../styles/profile.css"
import { useContext, useEffect, useLayoutEffect, useState } from "react";
import PositionsAPI from "../API/PositionsAPI";
import AssociationsAPI from "../API/AssociationsAPI";
import Dropbox from "../components/ui/Dropbox";
import { Context } from "..";
import AssociacionsAPI from "../API/AssociationsAPI";
import Clicker from "../components/ui/Clicker";
import AuthAPI from "../API/AuthAPI";
import { ReactComponent as SuccessIcon } from "../images/icons/success.svg";
import { ReactComponent as ErrorIcon } from "../images/icons/error.svg";

const Profile = () => {
    const { store } = useContext(Context);
    const [workers, setWorkers] = useState([]);
    const [associations, setAssociations] = useState({ mainkeeper_id: null, primary_id: null, payday_id: null, bank_id: null, fta_id: null, loan_id: null });
    const [isOpenedDropbox, setIsOpenedDropbox] = useState(null);
    const [dropboxes, setDropboxes] = useState({
        mainKeeper: {
            values: [],
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
        primary: {
            values: [],
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
        payday: {
            values: [],
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
        bank: {
            values: [],
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
        fta: {
            values: [],
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
        loan: {
            values: [],
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
    });
    const [workTime, setWorkTime] = useState(0);
    const [discountPrice, setDiscountPrice] = useState(0);

    useLayoutEffect(() => {
        loadWorkers().then(() => console.log("Список сотрудников загружен"));
    }, []);

    useEffect(() => {
        if (!store.userInfo) return;
        // if (store.userInfo.isLicensed == false) return;
        setWorkTime(store.userInfo.workTime);
        setDiscountPrice(store.userInfo.discountPrice);
        // console.log(store.userInfo.license)
        // console.log(store.userInfo.license.start.setMonth(store.userInfo.license.start.getMonth() + 1))
    }, [store.userInfo])
    
    const loadWorkers = async () => {
        try {
            const data = await PositionsAPI.getAll();
            setWorkers(data.data.positionsWorker);
            
            await loadAssociations(data.data.positionsWorker).then(() => console.log("[workers] Список сопоставлений загружен"));
        } catch(err) {
            console.log(`[profile] [workers] error: ${err}`);
        }
    }
    const loadAssociations = async (workersArray) => {
        try {
            if (!workersArray || workersArray.length == 0) return;
            let associationsData = await AssociationsAPI.getAll();
            associationsData = associationsData.data;
            setAssociations(associationsData);

            let newWorkers = [...workersArray];
            newWorkers.unshift({ name: "Нет" });

            let newDropboxes = {...dropboxes};
            newDropboxes.mainKeeper.values = 
            newDropboxes.primary.values = 
            newDropboxes.payday.values = 
            newDropboxes.bank.values = 
            newDropboxes.fta.values = 
            newDropboxes.loan.values = 
            newWorkers;

            for (let i = 1; i < newWorkers.length; i++) {
                let workerID = newWorkers[i].id;
                if (workerID == associationsData.mainkeeper_id) newDropboxes.mainKeeper.currentValue = i; 
                if (workerID == associationsData.primary_id) newDropboxes.primary.currentValue = i; 
                if (workerID == associationsData.payday_id) newDropboxes.payday.currentValue = i; 
                if (workerID == associationsData.bank_id) newDropboxes.bank.currentValue = i; 
                if (workerID == associationsData.fta_id) newDropboxes.fta.currentValue = i; 
                if (workerID == associationsData.loan_id) newDropboxes.loan.currentValue = i; 
            }
            setDropboxes(newDropboxes);
        } catch(err) {
            console.log(`[profile] [associations] error: ${err}`);
        }
    }

    // Dropbox Functions
    const changeOpenedDropbox = (dropboxName, state) => {
        let newDropboxes = { ...dropboxes };
        if (isOpenedDropbox != null) newDropboxes[isOpenedDropbox].isOpened = false;
        let newValue = { ...newDropboxes, [dropboxName]: { ...newDropboxes[dropboxName], isOpened: state } }
        setDropboxes(newValue);
        // updateCalcValues(newValue);

        if (state) setIsOpenedDropbox(dropboxName);
        else setIsOpenedDropbox(null);
    }
    const changeValueDropbox = (dropboxName, value) => {
        let newDropboxes = { ...dropboxes, [isOpenedDropbox]: { ...dropboxes[isOpenedDropbox], isOpened: false } };
        let newValue = { ...newDropboxes, [dropboxName]: { ...newDropboxes[dropboxName], currentValue: value } };
        setDropboxes(newValue);

        let newAssociations = {...associations};
        if (dropboxName == "mainKeeper") newAssociations.mainkeeper_id = value != 0 ? workers[value-1].id : null;
        else if (dropboxName == "primary") newAssociations.primary_id = value != 0 ? workers[value-1].id : null;
        else if (dropboxName == "payday") newAssociations.payday_id = value != 0 ? workers[value-1].id : null;
        else if (dropboxName == "bank") newAssociations.bank_id = value != 0 ? workers[value-1].id : null;
        else if (dropboxName == "fta") newAssociations.fta_id = value != 0 ? workers[value-1].id : null;
        else if (dropboxName == "loan") newAssociations.loan_id = value != 0 ? workers[value-1].id : null;
        setAssociations(newAssociations);
        saveAssociacions(newAssociations);
    }

    const saveAssociacions = async (associationsArray) => {
        try {
            const status = await AssociacionsAPI.update(associationsArray);
            console.log(status.status == 200 ? "Сопоставления сотрдуников сохранены" : status);
        } catch(err) {
            console.log("[profile] [associations] error:", err);
        }
    }

    const formatDate = (date) => {
        var dd = date.getDate();
        if (dd < 10) dd = '0' + dd;
        
        var mm = date.getMonth() + 1;
        if (mm < 10) mm = '0' + mm;
        
        var yy = date.getFullYear();
        if (yy < 10) yy = '0' + yy;
        
        return dd + '.' + mm + '.' + yy;
    }

    const changeWorkTime = async (value) => {
        try {
            if (value == workTime) return;
            setWorkTime(value);
            const response = await AuthAPI.editWorkTime(value);
            if (response.status == 200) console.log("[+] Рабочее время изменено на", value);
            else throw response;
        } catch (err) {
            console.log("[x] Ошибка изменения параметра рабочего времени:", err);
        }
    }

    const changeDiscountPrice = async (value) => {
        try {
            if (value == workTime) return;
            setDiscountPrice(value);
            const response = await AuthAPI.editDiscountPrice(value);
            if (response.status !== 200) throw response;

            console.log("[+] Процент наценки изменен на:", value);
        } catch (err) {
            console.log("[x] Ошибка изменения параметра рабочего времени:", err);
        }
    }

    return (
        <div className="profileBlock">
            <div className="info_block" style={{ marginBottom: "15px" }}>
                <div className="left">
                    <div className="block_el">
                        <div className="title">Данные профиля</div>
                        <ul>
                            <li>
                                <div className="name">Имя</div>
                                <div className="value">{store.userInfo.name}</div>
                            </li>
                            <li>
                                <div className="name">Фамилия</div>
                                <div className="value">{store.userInfo.surname != '' ? store.userInfo.surname : "-"}</div>
                            </li>
                            <li>
                                <div className="name">Email</div>
                                {/* <div className="value notBlur">randomuser42@gmail.com</div> */}
                                <div className="value notBlur">{store.userInfo.email}</div>
                            </li>
                            <li>
                                <div className="name">Пароль</div>
                                <div className="value">Пароль скрыт</div>
                            </li>
                            <li>
                                <div className="title">
                                    <div className={`icon${store.userInfo.isActivated ? "" : " error"}`}>{store.userInfo.isActivated ? <SuccessIcon/> : <ErrorIcon/>}</div>
                                    <div className="text">Аккаунт{store.userInfo.isActivated == false ? " не" : ""} активирован</div>
                                </div>
                                { store.userInfo.isActivated == false && <button className="activeButton disabled">Запросить письмо</button> }
                            </li>
                        </ul>
                        <button className="activeButton disabled">Изменить</button>
                    </div>
                    <div className="block_el">
                        <div className="title">Данные о тарифе</div>
                        {store.userInfo.license && <ul>
                            <li>
                                <div className="name">Тариф</div>
                                <div className="value blue">{store.userInfo.license.name}</div>
                            </li>
                            <li>
                                <div className="name">Дата оплаты</div>
                                <div className="value">{formatDate(new Date(store.userInfo.license.start))} г.</div>
                            </li>
                            <li>
                                <div className="name">Следующая оплата</div>
                                <div className="value">{formatDate(new Date(store.userInfo.license.end))} г.</div>
                            </li>
                        </ul>}
                        <button className="activeButton disabled">Пополнить баланс</button>
                    </div>
                </div>
                <div className="block_el right" style={{ gridArea: "list" }}>
                    <div className="title">История транзакций</div>
                    {/* <div className="managementLine"></div> */}
                    <div className="history">
                        <ul>
                            {/* <li>
                                <div className="month">Март</div>
                                <div className="description">
                                    <div className="rate">
                                        <div className="name">Тариф "Расширенный"</div>
                                        <div className="date">10.03.2025 г. в 10:00</div>
                                    </div>
                                    <div className="price">15 520 ₽</div>
                                </div>
                            </li> */}
                        </ul>
                    </div>
                </div>
            </div>
            <div className="splitBlock">
                { store.userInfo.isLicensed && workers && workers.length > 0 && <div className="associations_block">
                    <div className="block_el">
                        <div className="title">Настройка ответственных</div>
                        <ul>
                            <li>
                                <div className="name">Главный бухгалтер</div>
                                <div className="param">
                                    <Dropbox 
                                        textValue={dropboxes.mainKeeper.values[dropboxes.mainKeeper.currentValue]?.name}
                                        isRight={true}
                                        isOpen={dropboxes.mainKeeper.isOpened}
                                        changeOpened={(value) => changeOpenedDropbox("mainKeeper", value)}
                                    >
                                        {dropboxes.mainKeeper.values.map((item, index) => <li 
                                            className={dropboxes.mainKeeper.currentValue === index || (dropboxes.mainKeeper.currentValue === null && index == 0) ? "selected" : ""}
                                            key={item+index}
                                            onClick={() => changeValueDropbox("mainKeeper", index)}
                                        >
                                            <div className="number">{index+1}.</div>
                                            <div className="value">{item.name}</div>
                                        </li>)}
                                    </Dropbox>
                                </div>
                            </li>
                            <li>
                                <div className="name">Первичка</div>
                                <div className="param">
                                    <Dropbox 
                                        textValue={dropboxes.primary.values[dropboxes.primary.currentValue]?.name}
                                        isRight={true}
                                        isOpen={dropboxes.primary.isOpened}
                                        changeOpened={(value) => changeOpenedDropbox("primary", value)}
                                    >
                                        {dropboxes.primary.values.map((item, index) => <li 
                                            className={dropboxes.primary.currentValue === index || (dropboxes.primary.currentValue === null && index == 0) ? "selected" : ""}
                                            key={item+index}
                                            onClick={() => changeValueDropbox("primary", index)}
                                        >
                                            <div className="number">{index+1}.</div>
                                            <div className="value">{item.name}</div>
                                        </li>)}
                                    </Dropbox>
                                </div>
                            </li>
                            <li>
                                <div className="name">Зарпалата</div>
                                <div className="param">
                                    <Dropbox 
                                        textValue={dropboxes.payday.values[dropboxes.payday.currentValue]?.name}
                                        isRight={true}
                                        isOpen={dropboxes.payday.isOpened}
                                        changeOpened={(value) => changeOpenedDropbox("payday", value)}
                                    >
                                        {dropboxes.payday.values.map((item, index) => <li 
                                            className={dropboxes.payday.currentValue === index || (dropboxes.payday.currentValue === null && index == 0) ? "selected" : ""}
                                            key={item+index}
                                            onClick={() => changeValueDropbox("payday", index)}
                                        >
                                            <div className="number">{index+1}.</div>
                                            <div className="value">{item.name}</div>
                                        </li>)}
                                    </Dropbox>
                                </div>
                            </li>
                            <li>
                                <div className="name">Банк</div>
                                <div className="param">
                                    <Dropbox 
                                        textValue={dropboxes.bank.values[dropboxes.bank.currentValue]?.name}
                                        isRight={true}
                                        isOpen={dropboxes.bank.isOpened}
                                        changeOpened={(value) => changeOpenedDropbox("bank", value)}
                                    >
                                        {dropboxes.bank.values.map((item, index) => <li 
                                            className={dropboxes.bank.currentValue === index || (dropboxes.bank.currentValue === null && index == 0) ? "selected" : ""}
                                            key={item+index}
                                            onClick={() => changeValueDropbox("bank", index)}
                                        >
                                            <div className="number">{index+1}.</div>
                                            <div className="value">{item.name}</div>
                                        </li>)}
                                    </Dropbox>
                                </div>
                            </li>
                            <li>
                                <div className="name">ВЭД</div>
                                <div className="param">
                                    <Dropbox 
                                        textValue={dropboxes.fta.values[dropboxes.fta.currentValue]?.name}
                                        isRight={true}
                                        isOpen={dropboxes.fta.isOpened}
                                        changeOpened={(value) => changeOpenedDropbox("fta", value)}
                                    >
                                        {dropboxes.fta.values.map((item, index) => <li 
                                            className={dropboxes.fta.currentValue === index || (dropboxes.fta.currentValue === null && index == 0) ? "selected" : ""}
                                            key={item+index}
                                            onClick={() => changeValueDropbox("fta", index)}
                                        >
                                            <div className="number">{index+1}.</div>
                                            <div className="value">{item.name}</div>
                                        </li>)}
                                    </Dropbox>
                                </div>
                            </li>
                            <li>
                                <div className="name">Тарифные опции (займы)</div>
                                <div className="param">
                                    <Dropbox 
                                        textValue={dropboxes.loan.values[dropboxes.loan.currentValue]?.name}
                                        isRight={true}
                                        isOpen={dropboxes.loan.isOpened}
                                        changeOpened={(value) => changeOpenedDropbox("loan", value)}
                                    >
                                        {dropboxes.loan.values.map((item, index) => <li 
                                            className={dropboxes.loan.currentValue === index || (dropboxes.loan.currentValue === null && index == 0) ? "selected" : ""}
                                            key={item+index}
                                            onClick={() => changeValueDropbox("loan", index)}
                                        >
                                            <div className="number">{index+1}.</div>
                                            <div className="value">{item.name}</div>
                                        </li>)}
                                    </Dropbox>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div> }
                { store.userInfo && <div className="timeWork">
                    <div className="block_el">
                        <div className="title">Время работы в месяц</div>
                        <ul>
                            <li>
                                <div className="name">Время (в часах)</div>
                                <div className="param">
                                    <Clicker
                                        isDecimal={true}
                                        step={1}
                                        value={workTime}
                                        setValue={(newValue) => changeWorkTime(newValue)}
                                        disabled={!store.userInfo || store.userInfo.isLicensed == false}
                                    />
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="block_el">
                        <div className="title">Наценка на услуги</div>
                        <ul>
                            <li>
                                <div className="name">Процент наценки</div>
                                <div className="param">
                                    <Clicker
                                        isDecimal={true}
                                        step={1}
                                        value={discountPrice}
                                        setValue={(newValue) => changeDiscountPrice(newValue)}
                                        min={0}
                                        max={100}
                                        disabled={!store.userInfo || store.userInfo.isLicensed == false}
                                    />
                                </div>
                            </li>
                        </ul>
                    </div>
                </div> }
            </div>
        </div>
    )
}

export default observer(Profile);
